var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentBank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7087 38.7087V36.1339H37.4173V32.2677H36.126V16.811H37.4173V12.9449H38.7087V8.66929L20 0L1.29134 8.66929V12.9449H2.58268V16.811H3.87402V32.2677H2.58268V36.1339H1.29134V38.7087H0V40H40V38.7087H38.7087ZM2.58268 11.6535V9.49606L20 1.41732L37.4173 9.48819V11.6535H2.58268ZM23.2283 32.2677V16.811H24.5197V12.9449H28.3937V16.811H29.685V32.2677H28.3937V36.1339H24.5197V32.2677H23.2283ZM10.3228 32.2677V16.811H11.6142V12.9449H15.4882V16.811H16.7717V32.2677H15.4803V36.1339H11.6063V32.2677H10.3228ZM3.87402 15.5276V12.9528H10.3228V15.5276H3.87402ZM9.0315 16.811V32.2677H5.15748V16.811H9.0315ZM16.7717 33.5591H23.2283V36.1339H16.7717V33.5591ZM18.063 32.2677V16.811H21.937V32.2677H18.063ZM16.7717 15.5276V12.9528H23.2283V15.5276H16.7717ZM29.6772 33.5591H36.126V36.1339H29.6772V33.5591ZM30.9685 32.2677V16.811H34.8425V32.2677H30.9685ZM29.6772 15.5276V12.9528H36.126V15.5276H29.6772ZM3.87402 33.5591H10.3228V36.1339H3.87402V33.5591ZM37.4252 38.7087H37.4173H2.58268V37.4173H37.4252V38.7087Z",
    fill: "#0D1444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentBank);
export default __webpack_public_path__ + "static/media/payment_bank.b6457357ade2dc30d4ec130b2a0c3cf0.svg";
export { ForwardRef as ReactComponent };